import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectQueryStringNumberValue } from 'workspaces/react-router-selectors';
import { updateQueryString } from 'services/router/actions';
import { AppState } from 'services/types';

// @ts-ignore
import ResponsivePagination from 'components/ResponsivePagination';
import { EntityId } from 'services/entities/types';
import {
    SprayEventEndDate,
    SprayEventStartDate
} from 'services/sprayEvents/types';

interface OwnProps {
    entityId?: EntityId;
    startDate?: SprayEventStartDate;
    endDate?: SprayEventEndDate;
    count?: number;
    paginationName: string;
    length: number;
}

interface ConnectedProps {
    page: number;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = ConnectedProps & DispatchProps & OwnProps;

export class SprayEventsPaginationComponent extends React.PureComponent<Props> {
    static defaultProps = {
        length: 0,
        page: 1,
        count: 10
    };

    componentDidUpdate(): void {
        const {
            paginationName,
            length,
            page,
            count = 10,
            ...props
        } = this.props;

        if (
            page > 1 &&
            (length / count === 1 ||
                length <= count ||
                length <= count * (page - 1))
        ) {
            let pageValue;

            if (page > 2) {
                pageValue = page - 1;
            }

            props.updateQueryString({
                [paginationName]: pageValue
            });
        }
    }

    get totalPages(): number {
        const { length = 0, count = 10 } = this.props;
        return Math.ceil(Number(length) / count);
    }

    handlePageChange = (event: any, data: { activePage: number }): void => {
        const { paginationName } = this.props;

        this.props.updateQueryString({
            [paginationName]: data.activePage || undefined
        });

        global.scrollTo(0, 0);
    };

    render(): React.ReactElement | null {
        const { page } = this.props;

        if (this.totalPages <= 1 && page === 1) return null;

        return (
            <ResponsivePagination
                activePage={page}
                onPageChange={this.handlePageChange}
                totalPages={this.totalPages}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    page: (state: AppState, props: OwnProps) =>
        makeSelectQueryStringNumberValue(props.paginationName)(state, props)
});

export default connect(mapStateToProps, { updateQueryString })(
    SprayEventsPaginationComponent
);
